module.exports = __webpack_public_path__ + "static/img/bannerReport3Dlen.9cc5406a.png";